import createReducer, { ActionCreatorHelper } from 'store/createReducer';

type IsLoad = boolean;
type CampaignId = number | null;

// ----------------------- actions -------------------------------------
const SET_LOAD_CAMPAIGN_ADMIN_ACTION = 'SET_LOAD_CAMPAIGN_ADMIN_ACTION';
const SET_ID_FOR_CAMPAIGN_ADMIN_ACTION = 'SET_ID_FOR_CAMPAIGN_ADMIN_ACTION';

interface PayloadTypes {
    [SET_LOAD_CAMPAIGN_ADMIN_ACTION]: IsLoad;
    [SET_ID_FOR_CAMPAIGN_ADMIN_ACTION]: CampaignId;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setLoadCampaignAdminAction = ActionCreator(SET_LOAD_CAMPAIGN_ADMIN_ACTION);
export const setIdAdminAction = ActionCreator(SET_ID_FOR_CAMPAIGN_ADMIN_ACTION);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface AdminCampaignActionState {
    isLoad: IsLoad;
    campaignId: CampaignId;
}

export const ADMIN_CAMPAIGN_ACTION_INITIAL_STATE: AdminCampaignActionState = {
    isLoad: false,
    campaignId: null,
};

export default createReducer<AdminCampaignActionState, PayloadTypes>(ADMIN_CAMPAIGN_ACTION_INITIAL_STATE, {
    [SET_LOAD_CAMPAIGN_ADMIN_ACTION]: (state, { payload }) => ({
        ...state,
        isLoad: payload,
    }),
    [SET_ID_FOR_CAMPAIGN_ADMIN_ACTION]: (state, { payload }) => ({
        ...state,
        campaignId: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
